<template>
  <v-list-item v-if="product != null" class="border-bottom list-cart pa-0">
    <v-row class="ma-0">
    <v-col class="v-col-2 v-col-sm-1 v-col-lg-2 pa-0 d-flex align-center justify-center cursor-pointer" @click="Details()">
      <ImageProduct :image="product.image"></ImageProduct>
    </v-col>
    <v-col class="v-col-5 v-col-sm-6 v-col-lg-6 text-color-0 d-flex align-center text-small justify-start cursor-pointer" @click="Details()">
      {{ product.name }}
    </v-col>
    <v-col class="v-col-5 v-col-sm-5 v-col-lg-4 d-flex align-center justify-center pa-0 pe-2">
        <v-text-field variant="outlined" density="compact" :hide-details="true" v-model="textQtd" @keyup="updateItem()" readonly class="text-center border-color-1" v-if="item != null && item.cart.amount > 0 && kgund == 1">
          <template v-slot:prepend-inner>
            <div @click="removeItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
              <v-icon icon="mdi-minus"/>
            </div>
          </template>
          <template v-slot:append-inner>
            <div @click="addItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
              <v-icon icon="mdi-plus"/>
            </div>
          </template>
        </v-text-field>
        <v-text-field variant="outlined" density="compact" :hide-details="true" v-model="qtd" @keyup="updateItem()" class="text-center border-color-1" v-else-if="item != null && item.cart.amount > 0 && kgund == 0">
          <template v-slot:prepend-inner>
            <div @click="removeItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
              <v-icon icon="mdi-minus"/>
            </div>
          </template>
          <template v-slot:append-inner>
            <div @click="addItem()" class="px-3 h-100 text-color-2 cursor-pointer d-flex align-center justify-center">
              <v-icon icon="mdi-plus"/>
            </div>
          </template>
        </v-text-field>
        <v-btn variant="outlined" block class="br-5 text-color-2" v-else @click="addItem()">ADICIONAR</v-btn>
    </v-col>
    </v-row>
</v-list-item>
</template>
<script>
import ImageProduct from '@/components/ImageProduct.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'ProductList',
  components: {
    ImageProduct
  },
  props: {
    product: {
      type: Object,
      default: null
    },
    reloadFamily: {
      type: Function,
      required: true
    }
  },
  data(){
    return {
      qtd: 0,
      kgund: 0,
    }
  },
  computed: {
    ...mapGetters('cart', {
      getItemById: 'getItemById'
    }),
    ...mapGetters('main', {
      getConfig: 'getConfig'
    }),
    item: function() {
      let retorno = this.product ? this.getItemById(this.product.sku) : null;
      return retorno ? JSON.parse(JSON.stringify(retorno)) : null;
    },
    textQtd: function () {
      if (this.qtd < 1) {
          return Number(Math.round((this.qtd * 1000) + 'e0') + 'e-0')+'g';
      } else {
          return Number.isInteger(this.qtd) ? (Number(Math.round((this.qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((this.qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
      }
    }
  },
  watch: {
    item(i) {
      this.qtd = i != null ? i.cart.amount : 0;
    },
  },
  methods: {
    ...mapActions('cart', {
      updateItemCart: 'updateItemCart'
    }),
    ...mapActions('products', {
      addProduct: 'addProduct',
      connectActivate: 'connectActivate'
    }),
    Details(){
      this.addProduct(this.product);
      this.$router.push('/details/'+this.product.barcode);
    },
    updateItem(){
      this.setQtd(parseFloat(this.qtd));
    },
    setQtd(qtd){
      if(qtd == null){
        qtd = (this.kgund == 1 && this.product.cfg != null && this.product.cfg.minimum_amount > 0) ? this.product.cfg.minimum_amount : 1;
      }
      if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
        this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
        this.qtd = this.product.limit_quantity;
      } else {
        this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
          this.emitter.emit('sendCart');
        }.bind(this));
      }
    },
    addItem(add){
      if(add == undefined && this.qtd == 0 && this.product.offer != null && this.product.offer.is_offer_club == 0 && this.product.offer.offer_connect > 0 && this.product.offer.dh_activated == null){
        this.emitter.emit('dialogMessage', { title: "Ative e Pague!", message: "Deseja ativar o desconto e economizar?", response: this.activateAction });
      } else {
        let qtd = this.qtd;
        if(qtd == 0){
          qtd = this.product.is_kg == 1 && this.product.cfg != null && this.product.cfg.minimum_amount > 0 ? this.product.cfg.minimum_amount : 1;
        } else {
          qtd = qtd + (this.product.cfg != null && this.product.cfg.fractional_amount > 0 ? this.product.cfg.fractional_amount : 1);
        }
        if(this.product.limit_quantity > 0 && this.product.limit_quantity < qtd){
          this.emitter.emit('dialogMessage', { title: "Atenção", message: "Produto com limitação de estoque, no momento apenas é permitido a compra de " + this.product.limit_quantity + " " +(this.product.is_kg == 1 ? 'kg' : 'unds') });
        } else {
          this.updateItemCart({ item: this.product, qtd: qtd, kgund: this.kgund }).then(function (){
            this.emitter.emit('sendCart');
          }.bind(this));
        }
      }
    },
    removeItem(){
      this.updateItemCart({ item: this.product, qtd: this.qtd - ((this.kgund == 1 && this.product.cfg != null) ? this.product.cfg.fractional_amount : 1), kgund: this.kgund }).then(function (){
        this.emitter.emit('sendCart');
      }.bind(this));
    },
    activateAction: function(r, add){
      if(r){
        if(this.getConfig.isu > 0){
          this.connectActivate(this.product, add).then(function (retorno){
            this.product.offer.dh_activated = retorno;
            this.reloadFamily();
            if(add != true){
              this.addItem(true);
            }
          }.bind(this));
        } else {
          this.emitter.emit('dialogLogin');
        }
      } else {
        this.addItem(true);
      }
    },
  },
  mounted(){
    if(this.item && this.item.cart){
      this.qtd = this.item.cart.amount;
      this.kgund = this.item.cart.type_unit;
    } else {
      this.kgund = this.product.is_kg == 1;
    }
  }
}
</script>